import { ChangeDetectorRef, Component, input, OnDestroy, OnInit } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';
import { SafeHtmlMinPipe } from '@shared/pipes/safe-html-min.pipe';
import { UntilDestroy } from '@ngneat/until-destroy';
import { IHome_SpotlightsResponse } from '@shared/constants/models.const';
import { Router } from '@angular/router';
import { HelperService } from '../../../services/helper.service';
import { E_DATE_FORMAT } from '@shared/constants/enums.const';
import { StripHtml } from '@shared/pipes/strip-html';

@UntilDestroy()
@Component({
  selector: 'app-carousel',
  imports: [
    SafeHtmlPipe,
    SafeHtmlMinPipe,
    StripHtml,
  ],
  templateUrl: './carousel.component.html',
  styleUrl: './carousel.component.scss',
})
export class CarouselComponent implements OnInit, OnDestroy {
  images = input.required<IHome_SpotlightsResponse[]>();
  currentSlideIndex = 0;
  dotsLength: number[] = [];
  protected readonly E_DATE_FORMAT = E_DATE_FORMAT;
  private autoAdvanceSubscription!: Subscription;

  ngOnInit() {
    this.dotsLength = [...Array(this.images()?.length).keys()];
    this.setAutoplay();
  }

  setAutoplay(): void {
    this.autoAdvanceSubscription = interval(5000)
      .subscribe(() => {
        this.nextSlide();
        this.cd.detectChanges();
      });
  }

  ngOnDestroy() {
    this.autoAdvanceSubscription.unsubscribe();
  }

  nextSlide() {
    this.currentSlideIndex = (this.currentSlideIndex + 1) % this.images().length;
  }

  goToSlide(index: number) {
    this.currentSlideIndex = index;
    // remove previous count and start new one
    this.autoAdvanceSubscription.unsubscribe();
    this.setAutoplay();
  }

  navigate(image: IHome_SpotlightsResponse) {

    this.router.navigate([`${this.HELPER.frLoc}/${image.sourceUrl}`]);
  }

  constructor(
    private cd: ChangeDetectorRef,
    private router: Router,
    public HELPER: HelperService,
  ) {}
}
